import { useState, useEffect, useCallback } from 'react';
import api from '@/services/api';

export interface AvailableNode {
    id: string;
    default_name: string;
    description: string;
    ui_settings: {
        icon: string;
        category: string;
    };
}

export const useAvailableNodes = () => {
    const [nodes, setNodes] = useState<AvailableNode[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchNodes = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await api.get<AvailableNode[]>('/api/v1/workflows/available_nodes');
            setNodes(response.data);
        } catch (err: any) {
            let errorMessage = 'Error fetching available nodes';

            if (err.response?.status === 403) {
                errorMessage = 'You are not authorized to access available nodes. Contact the administrator.';
            } else if (err.response?.status === 401) {
                errorMessage = 'Session expired. Please login again.';
            } else if (err.response?.data?.message) {
                errorMessage = err.response.data.message;
            } else if (err.message) {
                errorMessage = err.message;
            }

            setError(errorMessage);
            console.error('Error fetching available nodes:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchNodes();
    }, [fetchNodes]);

    return {
        nodes,
        loading,
        error,
        refetch: fetchNodes,
    };
};

